import { ref, onMounted, onUnmounted } from "vue";

export function useScrollAnimation(options = {}) {
  const { threshold = 0.1, rootMargin = "0px", triggerOnce = true } = options;
  const elementRef = ref(null);
  const isVisible = ref(false);

  let observer = null;

  onMounted(() => {
    const element = elementRef.value;
    if (!element) return;

    observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          isVisible.value = true;
          if (triggerOnce) {
            observer.unobserve(element);
          }
        } else if (!triggerOnce) {
          isVisible.value = false;
        }
      },
      { threshold, rootMargin }
    );

    observer.observe(element);
  });

  onUnmounted(() => {
    if (observer && elementRef.value) {
      observer.unobserve(elementRef.value);
    }
  });

  return { elementRef, isVisible };
}
